const supportedTxt = [
  { name: 'email', type: 'email' },
  { name: 'url', type: 'url' },
  { name: 'avatar', type: 'url' },
  { name: 'description', type: 'string' },
  { name: 'notice', type: 'string' },
  { name: 'keywords', type: 'string' },
  { name: 'vnd.twitter', type: 'string' },
  { name: 'vnd.github', type: 'string' }
];
export default supportedTxt;
